<template>
  <div class="dvTlacitko">
    <div class="flx">
      <div class="leva"></div>
      <div v-show="zobrazPravyObsah" class="prava"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tlacitkoAtd",
  data() {
    return {
      levyObsah: "",
      pravyObsah: "",
      zobrazPravyObsah: true
    };
  }
  /*,
  mounted() {
    this.preskupData();
  },
  methods: {
    preskupData: function() {
      this.levyObsah = "fdasfdas";

    }
  }
  */
};
</script>

<style lang="less">
@import "../../less/mixin.less";
#dvCenyBox .dvTlacitko {
  padding: 0 10px;
  .add-to-cart {
    margin-bottom: 19px;
    button.btn.add-to-cart-button {
      padding-left: 40px;
      padding-right: 40px;
    }
  }
  .flx {
    .flex;
    align-items: center;
    justify-content: space-between;
  }
  .cofidis-wrap {
    position: static;
    float: none;
    a.btn.btn-cofidis {
      background: none;
      border: none;
      color: #b1520d;
      font-size: 12px;
      max-width: 170px;
      padding: 0;
    }
  }
}
@media (min-width: 1200px) {
  #dvCenyBox .dvTlacitko .add-to-cart button.btn.add-to-cart-button {
    padding-left: 60px;
    padding-right: 60px;
  }
}
</style>
